"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (getSession) { return function (dialog) {
    return dialog.occupants_ids.filter(function (i) { return i !== getSession().user_id; })[0];
}; });
//# sourceMappingURL=getTalker.js.map